import { CLIENT_TELEMETRY_CAPS, redactTelemetryText } from 'shared/wide-event-kinds'

// Eager: breadcrumbs attach console text to error reports from the first paint, before telemetry loads.
const FORMAT_SPECIFIER = /%[sdifoOjc%]/g
const textOf = (arg: unknown): string | undefined =>
  arg instanceof Error ? `${arg.name}: ${arg.message}` : typeof arg === 'string' ? arg : undefined

/**
 * A console call as one redacted line: Error names and messages and string arguments only, the first argument's
 * format specifiers applied (`%s` from a string, anything else dropped), objects and numbers never. Pure.
 */
export function consoleMessage(args: unknown[]): string {
  const [first, ...rest] = args
  const parts: string[] = []
  let used = 0
  if (typeof first === 'string') {
    parts.push(
      first.replace(FORMAT_SPECIFIER, (spec) => {
        if (spec === '%%') return '%'
        const arg = rest[used]
        used += 1
        return spec === '%s' ? (textOf(arg) ?? '') : ''
      }),
    )
  } else {
    const text = textOf(first)
    if (text !== undefined) parts.push(text)
  }
  for (const arg of rest.slice(used)) {
    const text = textOf(arg)
    if (text !== undefined) parts.push(text.replace(FORMAT_SPECIFIER, ''))
  }
  return redactTelemetryText(parts.join(' '), CLIENT_TELEMETRY_CAPS.logMessage)
}
